import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { AbsenceTypeStateClass } from './interfaces/absenseTypeStateClass'
import { sortData } from '../../../common/timeLiveFunction'
const initialState: AbsenceTypeStateClass = {
    isLoading: false,
    status: 'idle',
    absenceTypeList: [],
    selectedRecord: {},
    isReload : false,
    sortOrder: 'asc',
    sortColumn: 'AbsenceDescription',
    search: '',
    pageNo: 1,
    pageSize: 10
}
interface IThunkApi {
    state: {
        absenceType: AbsenceTypeStateClass;
    },
}
export const getAccountAbsenceTypeAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'absenceType/getAccountAbsenceType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Absences', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const getAccountAbsenceTypeByIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'absenceType/getAccountAbsenceTypeById',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Absences/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    
    export const addAccountAbsenceTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'absenceType/addAccountAbsenceType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Absences/', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const updateAccountAbsenceTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'absenceType/UpdateAccountAbsenceType',
        async (arg, thunkApi) => {
            const { AccountAbsenceTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/v2/Absences/' + AccountAbsenceTypeId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAccountAbsenceTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'absenceType/deleteAccountAbsenceType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/Absences/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const deleteAllSelectedRecordAbsenceTypeAsync = createAsyncThunk
    <any,any,IThunkApi>
    (
        "paymentMethod/DeleteAllSelectedRecordAbsenceType",
        async(arg,thunkApi) =>{
            const response = await fetchAPI('api/v2/Absences/DeleteAllSelectedRecordAbsenceType/', 'DELETE', arg, true,'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json =await response.json();
            return json;
        
        }
    )
  
export const absenceTypeSlice = createSlice({
    name: 'absenceType',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = state.absenceTypeList.findIndex((item) => item.AccountAbsenceTypeId == action.payload);
            const newArray = [...state.absenceTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected : 1 };
            state.absenceTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.absenceTypeList.findIndex((item) => item.AccountAbsenceTypeId == action.payload);
            const newArray = [...state.absenceTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.absenceTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.absenceTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.absenceTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.absenceTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.absenceTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.absenceTypeList;
            state.absenceTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountAbsenceTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountAbsenceTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.absenceTypeList = [];
                } else {
                    state.absenceTypeList = payload.Data;
                    state.absenceTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
                state.isLoading = false;

            })
            .addCase(getAccountAbsenceTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;


            })
           .addCase(getAccountAbsenceTypeByIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getAccountAbsenceTypeByIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data[0];
                state.isLoading = false;

            })
            .addCase(getAccountAbsenceTypeByIdAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(addAccountAbsenceTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(addAccountAbsenceTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(addAccountAbsenceTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
           
            .addCase(updateAccountAbsenceTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(updateAccountAbsenceTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(updateAccountAbsenceTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            .addCase(deleteAccountAbsenceTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAccountAbsenceTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAccountAbsenceTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
            
            .addCase(deleteAllSelectedRecordAbsenceTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(deleteAllSelectedRecordAbsenceTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(deleteAllSelectedRecordAbsenceTypeAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })
    }
})
export const {
    resetSelectedRecordObjectInState,checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState, updateSorting, updatePagination
} = absenceTypeSlice.actions
 export const absenceTypeStateClass = (state: RootState) => state.absenceType
 export default absenceTypeSlice.reducer